import React from 'react'
import { connect } from 'react-redux'
import { Grid, CardContent } from '@mui/material'
import MrtReusableTable from '../../Utils/MrtReusableTable'
import { getImagesoundPlayers } from '../../../store/DeviceStatuses/actionCreator'
import { handleFireflySendEvent } from '../../Utils/FireFlyVnextHelpers'

export class ImagesoundPlayers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      imagesoundPlayers: [],
      loading: true,
    }
    this.baseState = { ...this.state }
  }

  async componentDidMount() {
    const { userInfo } = this.props
    this.setState({ loading: true })
    await this.props.getImagesoundPlayers()
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Imagesound Players',
        'Imagesound Players Tab Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
    },
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.imagesoundPlayers.length) {
      this.setState({
        imagesoundPlayers: JSON.parse(
          JSON.stringify(nextProps.imagesoundPlayers),
        ),
        loading: false,
      })
    }
  }

  render() {
    let imagesoundPlayers = []
    const imagesoundColumns = [
      {
        header: 'T#',
        accessorKey: 'locationCode',
        size: 60,
        Cell: ({ cell }) => {
          let displayedTNum
          if (cell.getValue() === '') {
            displayedTNum = 'Spare'
          } else {
            displayedTNum = cell.getValue()
          }
          return displayedTNum
        },
      },
      { header: 'Player Name', accessorKey: 'playerName', size: 320 },
      { header: 'Player ID', accessorKey: 'playerId', size: 100 },
      { header: 'MAC Address', accessorKey: 'macAddress' },
      {
        header: 'Last transaction',
        accessorKey: 'lastTransaction',
        Cell: ({ cell }) => {
          let displayedDateTime
          if (cell.getValue() === 'N/A') {
            displayedDateTime = 'N/A'
          } else {
            const formattedDate = new Date(cell.getValue()).toLocaleDateString()
            const unformattedDate = new Date(cell.getValue())
            const hours = unformattedDate.getHours()
            const minutes = unformattedDate.getMinutes()
            let displayHours
            let amPm
            if (hours > 12) {
              displayHours = hours - 12
              amPm = 'PM'
            } else if (hours === 0) {
              displayHours = 12
              amPm = 'AM'
            } else {
              displayHours = hours
              amPm = 'AM'
            }
            const displayMinutes = (minutes < 10 ? '0' : '') + minutes
            displayedDateTime =
              formattedDate +
              ' - ' +
              displayHours +
              ':' +
              displayMinutes +
              ' ' +
              amPm
          }
          return displayedDateTime
        },
      },
      {
        header: 'Status',
        accessorKey: 'status',
        Cell: ({ cell }) => {
          let displayedStatus
          if (cell.getValue() === 2) {
            displayedStatus = 'online'
          } else {
            displayedStatus = 'offline'
          }
          return displayedStatus
        },
        muiTableBodyCellProps: ({ cell }) => {
          const value = cell.getValue()
          let backgroundColor = '#bdbdbd' // default gray
          if (value === 2) backgroundColor = '#228B22'
          else backgroundColor = '#FF0000'
          return {
            style: {
              backgroundColor: backgroundColor,
            },
          }
        },
      },
    ]

    const defaultColumns = [
      'locationCode',
      'playerName',
      'playerId',
      'macAddress',
      'lastTransaction',
      'status',
    ]

    imagesoundPlayers = (
      <MrtReusableTable
        pageSize={[10, 20, 50]}
        pageTitle={'Imagesound Players'}
        columns={imagesoundColumns}
        rowData={this.props.imagesoundPlayers}
        defaultColumns={defaultColumns}
        loading={this.state.loading}
        loadingMessage="Loading Imagesound Players..."
      />
    )

    const imagesoundPanel = <div>{imagesoundPlayers}</div>

    return (
      <CardContent
        style={{
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto',
        }}
      >
        <Grid
          container
          direction="row"
          spacing={8}
          justifyContent="space-evenly"
          alignItems="center"
        >
          <Grid item size={{ xs: 12 }}>
            {imagesoundPanel}
          </Grid>
        </Grid>
      </CardContent>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    imagesoundPlayers: state.deviceStatuses.imagesoundPlayers,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  getImagesoundPlayers,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImagesoundPlayers)
